/** @format */

import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { recargarComponente } from "../../redux/slices/userSlice";
import Swal from "sweetalert2";

export const ModalFactura = ({ showModal, closeModal, idPago }) => {
  const [razonSocial, setrazonSocial] = useState("");
  const [rfc, setRFC] = useState("");
  const [regimenF, setRegimenF] = useState("");
  const [correo, setCorreo] = useState("");
  const [codigoPostal, setCodigoPostal] = useState("");
  const [datosFiscales, setDatosFiscales] = useState(null);
  const [regimenFiscal, setRegimenFiscal] = useState([]);
  const path = useSelector((state) => state.sitePath);
  const dispatch = useDispatch();
  const pagos = useSelector((state) => state.pagos);
  const user = useSelector((state) => state.user.id);

  useEffect(() => {
    axios
      .get(
        "https://www.fundacionunam.org.mx/API/catalogos.php?t=regimen_fiscal"
      )
      .then((response) => {
        setRegimenFiscal(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener regimen fiscal:", error);
      });

    axios
      .post(`${path}/datosFiscales.php`, { id_usuario: user })
      .then((response) => {
        if (response.data !== "No data" && typeof response.data === "object") {
          setDatosFiscales(response.data);
        }
      })
      .catch((error) => {
        console.error("Error al obtener datos fiscales:", error);
      });
  }, [path, user]);

  useEffect(() => {
    if (datosFiscales) {
      setRFC(datosFiscales.rfc || "");
      setrazonSocial(datosFiscales.razon_social || "");
      setCorreo(datosFiscales.correo || "");
      setCodigoPostal(datosFiscales.cp || "");
      setRegimenF(datosFiscales.id_regimen || "");
    }
  }, [datosFiscales]);

  const handleRegistra = () => {
    const pagoEncontrado = pagos.find((pago) => pago.id === idPago);

    if (!pagoEncontrado) return;

    let data = {
      timbrar: true,
      serie: "A",
      metodoPago: "PPD",
      numCertificado: "30001000000500003316",
      importePagado: pagoEncontrado.importe_pagado,
      importeTotalPagado: pagoEncontrado.importe_pagado,
      correo,
      rfc,
      nombreReceptor: razonSocial,
      codigoPostal,
      id_regimen_fiscal_receptor: regimenF,
      refId: pagoEncontrado.id,
    };

    axios
      .post("http://localhost/facturacion_web/controller.php", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data.uuid) {
          Swal.fire({
            icon: "success",
            title: "Factura generada",
            text: "La factura se generó correctamente.",
          });

          let updateData = {
            uuid: response.data.uuid,
            id_pago: pagoEncontrado.id,
          };

          return axios.post(`${path}/actualiza_uuid.php`, updateData, {
            headers: { "Content-Type": "application/json" },
          });
        } else {
          let errorMessage =
            response.data.msj ||
            (response.data && response.data.msj) ||
            "Error desconocido al generar la factura";
          throw new Error(errorMessage);
        }
      })
      .then((updateResponse) => {
        Swal.fire({
          icon: "success",
          title: "UUID actualizado",
          text: "El UUID se ha actualizado correctamente en la base de datos.",
        });

        closeModal();
        dispatch(recargarComponente());
      })
      .catch((error) => {
        console.error("Error en el proceso:", error);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema en el proceso.",
        });
      });
  };

  return (
    <Modal
      show={showModal}
      onHide={closeModal}
      className='custom-modal'
    >
      <Modal.Header closeButton>
        <Modal.Title>Datos fiscales</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className='form-group'>
            <label>RFC:</label>
            <input
              type='text'
              className='form-control'
              value={rfc}
              onChange={(e) => setRFC(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Razón Social:</label>
            <input
              type='text'
              className='form-control'
              value={razonSocial}
              onChange={(e) => setrazonSocial(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Régimen Fiscal:</label>
            <select
              className='form-select'
              value={regimenF}
              onChange={(e) => setRegimenF(e.target.value)}
            >
              <option value=''>Elige régimen fiscal</option>
              {regimenFiscal.map((regimen) => (
                <option
                  key={regimen.id}
                  value={regimen.id}
                >
                  {regimen.Descripcion}
                </option>
              ))}
            </select>
          </div>
          <div className='form-group'>
            <label>Correo:</label>
            <input
              type='text'
              className='form-control'
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Código Postal:</label>
            <input
              type='text'
              id='correo'
              className='form-control'
              value={codigoPostal}
              onChange={(e) => setCodigoPostal(e.target.value)}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='secondary'
          onClick={closeModal}
        >
          Cerrar
        </Button>
        <Button
          variant='primary'
          onClick={handleRegistra}
        >
          Enviar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
